/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";
import { CircularProgress, Typography, Box } from "@material-ui/core";

const CircularProgressWithLabel = (props) => (
  <Box position="relative" display="inline-flex">
    <CircularProgress {...props} />
    <Box
      top={0}
      left={0}
      bottom={0}
      right={0}
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="caption" component="div">{`${Math.round(
        props.value
      )}%`}</Typography>
    </Box>
  </Box>
);

export default CircularProgressWithLabel;
